<div
  [matContextMenu]="contextMenu"
  [matContextMenuDisable]="mode === 'READ'"
  [attr.data-testid]="'flex-preview-container'"
>
  <ms-flex-preview
    [data]="regularizedFlex$ | async"
    [canSelect]="true"
    [attr.data-testid]="'flex-preview'"
    [class.error]="hasError"
  >
  </ms-flex-preview>
</div>

@if (hasError) {
  <div class="flex items-center justify-end py-2">
    <mat-icon class="text-red-500 mr-2 !h-[24px]">error</mat-icon>
    <span i18n>必填欄位資料有誤</span>
  </div>
}

<mat-menu #contextMenu class="tiny-menu">
  <button
    mat-menu-item
    (click)="editFlex()"
    i18n
    [attr.data-testid]="'edit-flex-button'"
  >
    <mat-icon>settings</mat-icon>編輯 FLEX
  </button>

  <mat-divider> </mat-divider>

  <button
    mat-menu-item
    (click)="delete()"
    i18n
    [attr.data-testid]="'delete-flex-button'"
  >
    <mat-icon>delete</mat-icon> 刪除
  </button>

  <button
    mat-menu-item
    (click)="swapUpward()"
    [disabled]="isFirstMessage"
    i18n
    [attr.data-testid]="'move-up-button'"
  >
    <mat-icon>arrow_upward</mat-icon> 上移
  </button>

  <button
    mat-menu-item
    (click)="swapDownward()"
    [disabled]="isLastMessage"
    i18n
    [attr.data-testid]="'move-down-button'"
  >
    <mat-icon>arrow_downward</mat-icon> 下移
  </button>
</mat-menu>
